import React from "react";

import FormComponent from "./form";
import Layout from "../Common/Layout";

export const LockScreen = ({ unlocked }) => {
    return (
        <Layout defaultStyle={{ zIndex: 9999, position: "fixed" }}>
            <FormComponent unlocked={unlocked} />
        </Layout>
    );
};
